/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';

interface ContentPreviewArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  isSaving: boolean;
  disabled: boolean;
  hasReadOnlyPermission: boolean;
}

export default class ContentPreview extends Component<ContentPreviewArgs> {
  get isDisabled() {
    let {
      actionAbstract: { action },
      isSaving,
      disabled,
    } = this.args;

    if (isSaving || disabled) {
      return true;
    }

    let hasAddContentButton = Boolean(action.info.showNoContent) && Boolean(action.hasNoContent);
    let hasAddRequestButton = Boolean(action.info.showRequest) && Boolean(action.hasNoRequest);
    return this.args.hasReadOnlyPermission && (hasAddContentButton || hasAddRequestButton);
  }
}
